import styled from 'styled-components';
import { SitemapMixin } from '@qover/typography';

export const Badge = styled.span`
  ${SitemapMixin};
  background-color: ${({ theme }) => theme.colors.textQuote()};
  border-radius: ${props => props.theme.borders.badgeRadius};
  box-shadow: 0 1px 3px 0 ${({ theme }) => theme.colors.textQuote(0.15)};
  color: #fff;
  padding: 4px 10px;

  svg {
    margin-right: 7px;
  }
`;

export const GhostBadge = styled.span`
  ${SitemapMixin};
  background-color: #fff;
  color: ${props => props.theme.colors.secondary()};
  border-radius: ${props => props.theme.borders.badgeRadius};
  border: 1px solid currentColor;
  padding: 4px 10px;

  svg {
    margin-right: 7px;

    path {
      fill: currentColor;
    }
  }

  &.rounded {
    border-radius: 12px;
  }
`;

export const BadgeAbsoluteContainer = styled.div`
  position: absolute;
  top: -10px;
`;
